"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _checkboxStateMixin = require("../checkboxStateMixin");
var _RadioMixin = require("./RadioMixin");
var zsgCSS = (0, _styledToken.default)('Radio.borderWidth', function (borderWidth) {
  return (0, _styledComponents.css)(["input&,input&:hover,input&:active,input&:focus{&:checked{border-width:", "px;}}"], borderWidth);
});

/** @class CheckboxMixin */
/** @method */
var CheckboxMixin = function CheckboxMixin(props) {
  return (0, _styledComponents.css)(["", " ", " ", " &:checked{", "}&&:indeterminate{", "}"], (0, _RadioMixin.RadioMixin)(props), zsgCSS(props), (0, _checkboxStateMixin.checkboxStateMixin)()(props), (0, _checkboxStateMixin.checkboxStateMixin)('checked')(props), (0, _checkboxStateMixin.checkboxStateMixin)('indeterminate')(props));
};
exports.CheckboxMixin = CheckboxMixin;